import { ReturnRequest, ReturnRequestStatus, ReturnRequestStatusValue, ReturnStatusHelper } from '@/app/shared/interface/order.interface';
import { OrderService } from '@/app/shared/services/order.service';
import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {Product} from "@/app/shared/interface/product.interface";

@Component({
  selector: 'app-return-order-detail',
  templateUrl: './return-order-detail.component.html',
  styleUrl: './return-order-detail.component.scss'
})
export class ReturnOrderDetailComponent {
  public ReturnRequestStatusValue = ReturnRequestStatusValue;
  loading = false;
  private _request?: ReturnRequest;
  @Input()
  set request(val: ReturnRequest | undefined) {
    this._request = val;
    this.populateExpiredDates();
  }
  get request(): ReturnRequest | undefined {
    return this._request;
  }

  @Input() productMap: Record<string, Product> = {};

  constructor(
    private route: ActivatedRoute,
    private orderService: OrderService
  ) {

  }

  ngOnInit() {
    if (!this.request) {
      this.route.queryParams.subscribe(params => {
        const id = params['id'];
        if (id) {
          this.fetchRequest(id);
        }
      });
    }
  }

  fetchRequest(id: string) {
    this.loading = true;
    this.orderService.retrieveReturnOrderById(id).subscribe({
      next: (res: ReturnRequest | undefined) => {
        this.request = res;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  populateExpiredDates() {
    if (!this._request?.items) return;
    this._request.items.forEach(returnOrder => {
      const order = returnOrder.order;
      if (order?.items && returnOrder.items) {
        returnOrder.items.forEach((item: any) => {
          if (!item.expiredDate) {
            const orderItem = order.items.find(x => x.sku === item.productSku || x.skU2 === item.productSku);
            if (orderItem?.expiredDate) {
              item.expiredDate = orderItem.expiredDate;
            }
          }
        });
      }
    });
  }

  getStatusClass(status: ReturnRequestStatus): string {
    return ReturnStatusHelper.getClass(status);
  }

  getProductInfo(sku: string): Product | undefined {
    return this.productMap[sku];
  }
  goBack() {
    window.history.back();
  }

  getShipmentInfo(sku: string, comboSku:string|null) {
    if (!this.request?.items?.length) return null;

    const order = this.request.items[0].order;
    if (!order?.shipments) return null;
    if(comboSku){
      for (const shipment of order.shipments) {
        const found = shipment.shipmentItems?.find(x => x.productSku === sku || x.combo_ProductSku === comboSku);
        if (found) return found;
      }
    }

    for (const shipment of order.shipments) {
      const found = shipment.shipmentItems?.find(x => x.productSku === sku);
      if (found) return found;
    }

    return null;
  }
}
